import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "./hooks/AuthProvider";

const RedirectToLogin = () => {
  const { authed, loading, passwordExpired, resetPasswordRequired } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    if (authed) {
      navigate(
        resetPasswordRequired
          ? "/reset-password"
          : passwordExpired
            ? "/force-change-password"
            : "/devices",
        { replace: true }
      );
    } else {
      navigate("/login", { replace: true });
    }
  }, [authed, loading, passwordExpired, resetPasswordRequired, navigate]);

  return null;
};

export default RedirectToLogin;
